exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n}\n\n:host {\n  max-height: 700px;\n  overflow-y: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/modals/manufacturing-order-pieces-change-form/manufacturing-order-pieces-change-form.component.css
// module id = ../../../../../src/app/shared/components/modals/manufacturing-order-pieces-change-form/manufacturing-order-pieces-change-form.component.css
// module chunks = main